export const isGithubToken = (value) => !!value.match(/^(github_pat_|ghp_|ghs_)/);
export const validateGithubToken = (value) => {
    if (!isGithubToken(value)) {
        return [
            false,
            `GitHub token should start with "github_pat_" or "ghp_"`,
        ];
    }
    return [true, undefined];
};
//# sourceMappingURL=github.js.map